import { BankAutofill } from "types/Models/bankAutofill";
import { ManualBankAccountValues } from "types/Models/manualBankAccount";
import {
  useCreateAutofillMutation,
  useUpdateAutofillMutation,
} from "store/apis/autofill";
import { SENSITIVE_DATA_BANK_AUTOFILL_KEY } from "constants/sensitiveData";

export const useSaveManualBankAccount = ({
  entityId,
  groupId,
}: {
  entityId: string;
  groupId: string;
}): {
  saveManualBankAccount: (
    values: ManualBankAccountValues,
    bankUuid?: string
  ) => Promise<BankAutofill>;
  isSavingBankAccount: boolean;
} => {
  const [createAutofill, { isLoading: isCreating }] =
    useCreateAutofillMutation();
  const [updateAutofill, { isLoading: isUpdating }] =
    useUpdateAutofillMutation();

  const saveManualBankAccount = (
    values: ManualBankAccountValues,
    bankUuid?: string
  ) => {
    const fields = {
      name: values.name,
      account_number: values.account_number,
      routing_number: values.routing_number,
      bank_details_entity_name: values.bank_details_entity_name,
      address_autofill_id: values.address,
      entity_id: entityId,
    };

    if (bankUuid) {
      return updateAutofill({
        groupId,
        entityId,
        autofillKey: SENSITIVE_DATA_BANK_AUTOFILL_KEY,
        uuid: bankUuid,
        fields,
      }).unwrap() as Promise<BankAutofill>;
    }

    return createAutofill({
      groupId,
      entityId,
      autofillKey: SENSITIVE_DATA_BANK_AUTOFILL_KEY,
      fields,
    }).unwrap() as Promise<BankAutofill>;
  };

  return {
    saveManualBankAccount,
    isSavingBankAccount: isCreating || isUpdating,
  };
};
